import React, { useState, useEffect } from 'react';
import { FaCalendarAlt, FaUser, FaArrowRight, FaSearch, FaNewspaper, FaTimes, FaWhatsapp } from 'react-icons/fa';
import axios from 'axios';
import { api } from '../api/apiClient';

const NewsAndUpdates = () => {
  const [newsUpdates, setNewsUpdates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedNews, setSelectedNews] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await api.get('/api/news-updates');
        console.log('API Response:', response.data);
        const data = Array.isArray(response.data) ? response.data : (response.data?.data || []);
        console.log('Processed data:', data);
        setNewsUpdates(data);
      } catch (error) {
        console.error('Error fetching news:', error);
        setNewsUpdates([]);
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, []);

  const filteredNews = Array.isArray(newsUpdates) ? newsUpdates.filter(news =>
    news.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    news.description?.toLowerCase().includes(searchQuery.toLowerCase())
  ) : [];

  // Custom icons
  const NewsIcon = () => (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"/>
    </svg>
  );

  const UrgentIcon = () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.342 16.5c-.77.833.192 2.5 1.732 2.5z"/>
    </svg>
  );

  // Coming Soon Image Component
  const ComingSoonImage = ({ urgent = false }) => (
    <div className={`w-full h-full flex flex-col items-center justify-center p-6 ${
      urgent 
        ? 'bg-gradient-to-br from-red-900/40 to-pink-900/30' 
        : 'bg-gradient-to-br from-purple-900/30 to-blue-900/20'
    }`}>
      <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${
        urgent 
          ? 'bg-gradient-to-r from-red-600/30 to-pink-600/30 border-2 border-red-500/30' 
          : 'bg-gradient-to-r from-purple-600/30 to-blue-600/30 border-2 border-purple-500/30'
      }`}>
        {urgent ? (
          <svg className="w-8 h-8 text-red-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.342 16.5c-.77.833.192 2.5 1.732 2.5z"/>
          </svg>
        ) : (
          <svg className="w-8 h-8 text-purple-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
          </svg>
        )}
      </div>
      <span className={`text-sm font-medium ${
        urgent ? 'text-red-200' : 'text-purple-200'
      }`}>
        Updates Coming Soon
      </span>
    </div>
  );

  return (
    <>
      {selectedNews && (
        <div className="fixed inset-0 z-[999999] flex items-center justify-center p-4 bg-black/90 backdrop-blur-xl overflow-y-auto" onClick={() => setSelectedNews(null)}>
          <div className="relative bg-gradient-to-br from-gray-900 via-purple-900/50 to-gray-900 rounded-3xl max-w-5xl w-full max-h-[90vh] overflow-hidden shadow-2xl border-2 border-purple-500/40 animate-fadeIn" onClick={(e) => e.stopPropagation()}>
            <div className="absolute top-4 right-4 z-20 flex gap-3">
              <button
                onClick={() => {
                  const formattedText = selectedNews.content?.replace(/\\n/g, '\n').replace(/&amp;/g, '&');
                  const text = encodeURIComponent(`*${selectedNews.title}*\n\n${formattedText}`);
                  window.open(`https://wa.me/?text=${text}`, '_blank');
                }}
                className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white p-4 rounded-full transition-all duration-300 transform hover:scale-110 shadow-xl hover:shadow-green-500/50"
              >
                <FaWhatsapp className="w-6 h-6" />
              </button>
              <button
                onClick={() => setSelectedNews(null)}
                className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white p-4 rounded-full transition-all duration-300 transform hover:scale-110 shadow-xl hover:shadow-red-500/50"
              >
                <FaTimes className="w-6 h-6" />
              </button>
            </div>

            <div className="overflow-y-auto max-h-[90vh]">
              {selectedNews.image && (
                <div className="relative w-full h-[400px] overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent z-10"></div>
                  <img
                    src={selectedNews.image}
                    alt={selectedNews.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              )}

              <div className="p-8 md:p-12">
                <h2 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400 mb-6 leading-tight">
                  {selectedNews.title}
                </h2>
                
                <div className="flex flex-wrap items-center gap-6 mb-8 pb-6 border-b border-purple-500/30">
                  {selectedNews.date && (
                    <div className="flex items-center gap-3 bg-purple-500/20 px-4 py-2 rounded-full">
                      <FaCalendarAlt className="text-purple-400 w-5 h-5" />
                      <span className="text-gray-300 font-medium">{new Date(selectedNews.date).toLocaleDateString()}</span>
                    </div>
                  )}
                  {selectedNews.author && (
                    <div className="flex items-center gap-3 bg-pink-500/20 px-4 py-2 rounded-full">
                      <span className="text-gray-300 font-medium">{selectedNews.author}</span>
                      <img src="/logo.png" alt="LFNC" className="w-6 h-6 rounded-full" />
                    </div>
                  )}
                </div>

                <div className="text-gray-200 text-lg leading-relaxed whitespace-pre-wrap break-words overflow-x-auto bg-white/5 p-6 rounded-2xl border border-white/10">
                  {selectedNews.content?.replace(/\\n/g, '\n').replace(/&amp;/g, '&')}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-blue-900 relative overflow-hidden">
      {/* Background Effects */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-gradient-to-br from-purple-500/20 via-pink-400/25 to-red-500/20 rounded-full mix-blend-multiply filter blur-3xl animate-pulse" />
        <div className="absolute top-60 -left-40 w-96 h-96 bg-gradient-to-br from-red-500/20 via-purple-400/25 to-blue-500/20 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-1000" />
        <div className="absolute -bottom-40 right-1/3 w-96 h-96 bg-gradient-to-br from-blue-500/15 via-purple-400/20 to-pink-500/15 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-2000" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-red-500 to-purple-600 rounded-full mb-8 shadow-xl">
            <NewsIcon />
          </div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6">
            News <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-400 to-red-400">&</span> Updates
          </h1>
          <p className="font-body text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-8">
            Stay informed about our church community updates and announcements
          </p>
          
          {/* Search Bar */}
          <div className="max-w-2xl mx-auto relative mb-12">
            <div className="relative">
              <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Search news and updates..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-12 pr-4 py-4 bg-white/10 backdrop-blur-lg border-2 border-white/30 rounded-2xl text-white placeholder-gray-400 focus:outline-none focus:border-purple-500 transition-all duration-300"
              />
            </div>
          </div>
        </div>

        {/* News Grid */}
        {loading ? (
          <div className="text-center py-20">
            <div className="inline-block animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-purple-500"></div>
            <p className="text-white mt-4">Loading news...</p>
          </div>
        ) : filteredNews.length === 0 ? (
          <div className="text-center py-20">
            <div className="inline-flex items-center justify-center w-24 h-24 bg-white/10 rounded-full mb-6">
              <FaNewspaper className="w-12 h-12 text-gray-400" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">No News & Updates Available</h3>
            <p className="text-gray-400">Check back later for new updates from our community</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredNews.map((news) => (
              <div key={news._id} className="group relative bg-gradient-to-br from-gray-900/90 to-gray-800/90 backdrop-blur-lg border border-purple-500/30 rounded-3xl overflow-hidden hover:border-purple-400/60 transition-all duration-500 hover:shadow-2xl hover:shadow-purple-500/30 hover:-translate-y-2">
                {news.image && (
                  <div className="relative h-56 overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent z-10"></div>
                    <img
                      src={news.image}
                      alt={news.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                )}
                
                <div className="p-6 space-y-4">
                  <h3 className="text-2xl font-bold text-white mb-2 line-clamp-2 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-purple-400 group-hover:to-pink-400 transition-all duration-300">
                    {news.title}
                  </h3>
                  
                  <p className="text-gray-300 text-sm leading-relaxed line-clamp-3">
                    {news.excerpt}
                  </p>
                  
                  <div className="flex items-center gap-4 pt-2 border-t border-white/10">
                    {news.date && (
                      <div className="flex items-center gap-2 text-xs text-gray-400">
                        <FaCalendarAlt className="text-purple-400" />
                        <span>{new Date(news.date).toLocaleDateString()}</span>
                      </div>
                    )}
                    {news.author && (
                      <div className="flex items-center gap-2 text-xs text-gray-400">
                        <FaUser className="text-purple-400" />
                        <span className="line-clamp-1">{news.author}</span>
                      </div>
                    )}
                  </div>
                  
                  <button 
                    onClick={() => setSelectedNews(news)}
                    className="w-full mt-4 flex items-center justify-center gap-2 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 transform group-hover:scale-105 shadow-lg hover:shadow-purple-500/50"
                  >
                    Read More
                    <FaArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <style jsx>{`
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        
        .line-clamp-3 {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
    </>
  );
};

export default NewsAndUpdates;